import type { MouseEventHandler } from 'react';
import CoreBreadcrumbs, {
    type BreadcrumbsProps as CoreBreadcrumbsProps,
} from '@ovpn/ui/breadcrumbs';

import { boxed } from '@sso/shared/hocs';

import Anchor from './Anchor';

type BreadcrumbsProps = Omit<CoreBreadcrumbsProps, 'children'> & {
    breadcrumbs: {
        onClick?: MouseEventHandler<HTMLAnchorElement>;
        name: string;
        to?: string;
        id: string;
    }[];
};

function Breadcrumbs({ breadcrumbs, ...props }: BreadcrumbsProps) {
    return (
        <CoreBreadcrumbs {...props}>
            {breadcrumbs.map(({ name, id, ...breadcrumb }, index) => (
                <Anchor
                    disabled={index === breadcrumbs.length - 1}
                    {...breadcrumb}
                    key={id}
                    id={id}
                >
                    {name}
                </Anchor>
            ))}
        </CoreBreadcrumbs>
    );
}

export default boxed(Breadcrumbs);
